export const fullNumberFormat = (number) => {
  const formatter = new Intl.NumberFormat('ja-JP', {
    notation: 'compact',
    useGrouping: false,
    maximumFractionDigits: 0,
  });
  const fmt = (number, result = []) => {
    // EslintがBigIntの対応するためにバージョンアップが必要なためdisableで回避
    // eslint-disable-next-line no-undef
    const bigIntNum = BigInt(number);
    const [num, notation] = formatter.formatToParts(bigIntNum);
    const numStr = bigIntNum.toString();

    if (notation === undefined) {
      // 0は省略する
      // 99,999,990,000円 ➡ 表示：999億9999万円（万未満の0を省略）
      if (numStr === '0') {
        return [...result].join('');
      }
      return [...result, numStr].join('');
    }

    const dig = num.value.length;
    const value = numStr.slice(0, dig);
    const next = numStr.slice(dig);

    return fmt(next, [...result, `${value}${notation.value}`]);
  };
  return fmt(number);
};
